<app-leave-page-confirmation
    #createFormConfirmOverlay
></app-leave-page-confirmation>
<!-- Delete Overlay -->
<app-confirmation-window
    #deleteConfirmationOverlay
    [mainLabel]="'forms.trend-graph.delete-confirmation-prompt' | translate"
    [confirmLabel]="'forms.trend-graph.delete-confirmation-button' | translate"
    [cancelLabel]="'forms.trend-graph.delete-cancel-button' | translate"
></app-confirmation-window>

<app-ops-alarm-to-top
    style="position: relative; z-index: 99"
    (onTopEmit)="scrollToTop()"
    *ngIf="shouldShowScrollTopButton() && viewMode === VIEWMODE_VIEW"
></app-ops-alarm-to-top>

<div
    [ngClass]="[
        'views-container',
        responsive.deviceAndOrientation,
        responsive.screenSize,
    ]"
    *ngIf="filteredTrendGraphs && viewMode == VIEWMODE_VIEW"
>
    <app-scroll-navigator
        class="scroll-navigator-container"
        [items]="filteredTrendGraphs"
        [selectedId]="targetViewIndex"
        [routerPath]="['/ops', 'trendgraphs', '']"
        [indexMode]="true"
    />

    <a (click)="openCreatePage()" class="create-group-button">
        <mat-icon svgIcon="blue-add" />
        <p style="text-wrap: nowrap">
            {{ "trend-graph.labels.add-graph" | translate }}
        </p>
    </a>
</div>
<div
    *ngIf="isInitComplete; else loadingSpinner"
    [ngClass]="[
        'trend-graph-container',
        responsive.deviceAndOrientation,
        responsive.screenSize,
    ]"
>
    <!-- View Window -->
    <div
        *ngIf="viewMode == VIEWMODE_VIEW && isSmallScreenDesign()"
        style="min-width: 100%"
    >
        <div
            style="
                min-width: 100px;
                display: flex;
                justify-content: flex-end;
                margin-top: 24px;
            "
            #topElementSmallView
        >
            <div class="create-button" (click)="openCreatePage()">
                <mat-icon svgIcon="blue-add" />
                {{ "trend-graph.create-graph.button.title" | translate }}
            </div>
        </div>
        <div class="input-container">
            <mat-icon class="search-icon" svgIcon="search"></mat-icon>
            <input
                type="text"
                class="text"
                [(ngModel)]="inputTrendGraph"
                placeholder="Search Channel Name or Number"
            />
        </div>
        <app-trend-graph-view
            *ngFor="
                let view of filteredTrendGraphs
                    | filterTrendGraph: inputTrendGraph
            "
            style="width: 100%"
            [view]="view"
            [channelLookup]="channelLookup"
            (onEditView)="editCurrentView()"
            (onDeleteView)="deleteCurrentView()"
        >
        </app-trend-graph-view>
    </div>
    <app-trend-graph-view
        style="width: 100%"
        *ngIf="viewMode == VIEWMODE_VIEW && !isSmallScreenDesign()"
        [view]="selectedView"
        [usersAccess]="selectedViewUsersAccess"
        [channelLookup]="channelLookup"
        (onEditView)="editCurrentView()"
        (onDeleteView)="deleteCurrentView()"
    >
    </app-trend-graph-view>

    <!-- Create Form -->
    <app-trend-graph-create
        #createForm
        style="width: 100%"
        *ngIf="viewMode == VIEWMODE_CREATE"
        (onCancel)="handleCancel($event)"
        [(view)]="createView"
        [views]="views"
        [channels]="channels"
        [channelLookup]="channelLookup"
        (onSubmit)="handleCreateFormSubmit($event)"
        [viewNameNumber]="projectViewsLength + 1"
    >
    </app-trend-graph-create>

    <!-- Edit Form -->
    <app-trend-graph-create
        #createForm
        style="width: 100%"
        *ngIf="viewMode == VIEWMODE_EDIT"
        (onCancel)="handleCancel($event)"
        [isEditing]="true"
        [(view)]="editView"
        [views]="views"
        [channels]="channels"
        [channelLookup]="channelLookup"
        [usersAccess]="selectedViewUsersAccess"
        (onSubmit)="handleCreateFormSubmit($event)"
    >
    </app-trend-graph-create>
</div>

<ng-template #loadingSpinner>
    <div class="loading-spinner-container">
        {{ "general.notification.retreiving-data" | translate }}
        <app-loading-spinner
            style="height: 200px; width: 200px"
        ></app-loading-spinner>
    </div>
</ng-template>
